// ── Mobile overlay (Odd Muse style) ─────────────────────────────
(function(){
  const overlay  = document.querySelector('[data-menu-overlay]');
  const scrim    = document.querySelector('[data-menu-scrim]');
  const openBtns = document.querySelectorAll('[data-menu-toggle]');
  const closeBtns= document.querySelectorAll('[data-menu-close]');
  if(!overlay) return;

  function open(){
    overlay.classList.add('is-open');
    scrim.classList.add('is-visible');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    openBtns.forEach(b=>{ b.classList.add('is-open'); b.setAttribute('aria-expanded','true'); });
  }
  function close(){
    overlay.classList.remove('is-open');
    scrim.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    openBtns.forEach(b=>{ b.classList.remove('is-open'); b.setAttribute('aria-expanded','false'); });
  }

  openBtns.forEach(b=>b.addEventListener('click', open));
  closeBtns.forEach(b=>b.addEventListener('click', close));
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', e=>{ if(e.key==='Escape') close(); });
})();

// ── Global quick-add (cards on every page: home, collections, search) ──
if(!window.__rvQuickAdd){
  window.__rvQuickAdd = true;
  (function(){
    function closeAll(except){
      document.querySelectorAll('.rv-card__qa-panel.is-open').forEach(function(p){
        if(p!==except) p.classList.remove('is-open');
      });
    }

    document.addEventListener('click', function(e){

      // 1. Quick-add toggle button clicked
      var t = e.target.closest('[data-qa-toggle]');
      if(t){
        e.preventDefault();
        var singleId = t.getAttribute('data-single-variant-id');
        if(singleId){
          // Single variant — add directly, no panel
          if(t.disabled) return;
          var orig = t.innerHTML;
          t.innerHTML = '<span class="rv-card__qa-label">Adding…</span>';
          t.disabled = true;
          fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({id:singleId, quantity:1})
          }).then(function(r){
            if(r.ok){
              t.innerHTML = '<span class="rv-card__qa-label">✓ Added</span>';
              fetch('/cart.js').then(function(c){return c.json();}).then(function(cart){
                var b = document.querySelector('[data-cart-count]');
                if(b) b.textContent = cart.item_count;
                document.dispatchEvent(new CustomEvent('rv:cart:updated',{detail:cart}));
              });
              setTimeout(function(){ t.innerHTML = orig; t.disabled = false; }, 1400);
            } else {
              t.innerHTML = orig; t.disabled = false;
            }
          }).catch(function(){ t.innerHTML = orig; t.disabled = false; });
        } else {
          // Multi-variant — show options panel
          var p = t.parentElement.querySelector('[data-qa-panel]');
          if(p){ closeAll(p); p.classList.toggle('is-open'); }
        }
        return;
      }

      // 2. Close panel button clicked
      var c = e.target.closest('[data-qa-close]');
      if(c){
        e.preventDefault();
        var pp = c.closest('[data-qa-panel]');
        if(pp) pp.classList.remove('is-open');
        return;
      }

      // 3. Variant add button clicked (inside panel or direct single-variant)
      var a = e.target.closest('[data-qa-add]');
      if(a && !a.disabled){
        e.preventDefault();
        var id = a.getAttribute('data-variant-id');
        if(!id) return;
        var orig = a.innerHTML;
        a.innerHTML = '<span class="rv-card__qa-label">Adding…</span>';
        a.disabled = true;
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:id, quantity:1})
        }).then(function(r){
          if(r.ok){
            a.innerHTML = '<span class="rv-card__qa-label">✓ Added</span>';
            fetch('/cart.js').then(function(c){return c.json();}).then(function(cart){
              var b = document.querySelector('[data-cart-count]');
              if(b) b.textContent = cart.item_count;
              document.dispatchEvent(new CustomEvent('rv:cart:updated',{detail:cart}));
            });
            setTimeout(function(){
              a.innerHTML = orig;
              a.disabled = false;
              var pa = a.closest('[data-qa-panel]');
              if(pa) pa.classList.remove('is-open');
            }, 1400);
          } else {
            a.innerHTML = orig; a.disabled = false;
          }
        }).catch(function(){ a.innerHTML = orig; a.disabled = false; });
        return;
      }

      // 4. Click outside any panel — close all
      if(!e.target.closest('[data-qa-panel]')) closeAll(null);
    });

    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(null); });
  })();
}

/* ── Rare Velvet Theme JS ────────────────────────────────────── */
(function(){
  // Sticky header
  var header = document.querySelector('.rv-header');
  var last = 0;
  if(header){
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      header.classList.toggle('rv-header--scrolled', y > 60);
      header.classList.toggle('rv-header--hidden', y > last + 10 && y > 140);
      last = y < 0 ? 0 : y;
    }, {passive:true});
  }
  // Mobile drawer
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var close  = document.querySelector('[data-menu-close]');
  if(toggle && drawer){
    toggle.addEventListener('click', function(){ drawer.classList.toggle('is-open'); document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : ''; });
  }
  if(close && drawer){
    close.addEventListener('click', function(){ drawer.classList.remove('is-open'); document.body.style.overflow = ''; });
  }
  // Newsletter form
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-newsletter-form]');
    if(!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type=email]');
    var msg   = form.querySelector('[data-form-msg]');
    if(!input || !input.value) return;
    if(msg) msg.textContent = 'Thank you! Check your inbox.';
    input.value = '';
  });
})();

// Sticky ATC bar — show after scrolling past the main ATC button
(function () {
  const bar = document.querySelector('[data-sticky-atc]');
  const mainAtc = document.querySelector('[data-atc-row]');
  if (!bar || !mainAtc) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    },
    { threshold: 0, rootMargin: '0px 0px -20px 0px' }
  );
  observer.observe(mainAtc);
})();

// ── Product page variant selector ────────────────────────────────
(function () {
  const form = document.getElementById('rv-product-form');
  if (!form) return;

  const variantsEl = document.querySelector('[data-product-json]');
  if (!variantsEl) return;
  const variants = JSON.parse(variantsEl.textContent);

const optionBtns = document.querySelectorAll('[data-option-btn]');
  const atcBtn         = form.querySelector('[data-atc-btn]');
  const priceEl        = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-product-compare-price]');
  const stickyAtcBtn   = document.querySelector('[data-sticky-atc-btn]');
  const stickyPrice    = document.querySelector('.rv-sticky-atc__price');
  const variantInput   = document.getElementById('rv-variant-input');

  // ── Reliable money formatter (no dependency on Shopify.formatMoney) ──
  function formatMoney(cents) {
  var currency = (Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD';
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
}


  // Build selected state from pre-selected buttons
  const selected = {};
  optionBtns.forEach(btn => {
    const idx = btn.getAttribute('data-option-index');
    if (btn.classList.contains('is-selected')) selected[idx] = btn.getAttribute('data-value');
  });

  function findVariant() {
    return variants.find(v =>
      v.options.every((opt, i) => selected[String(i + 1)] === opt)
    );
  }

  function updateUI(variant) {
    if (!variant) return;

    // Hidden input for form submission
    if (variantInput) variantInput.value = variant.id;

    // Price
    const price = formatMoney(variant.price);
    if (priceEl) priceEl.innerHTML = price;
    if (stickyPrice) stickyPrice.innerHTML = price;

    // Compare-at price
    if (comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.innerHTML = '';
        comparePriceEl.style.display = 'none';
      }
    }

    // ATC buttons
    const available = variant.available;
    const soldLabel  = atcBtn ? atcBtn.getAttribute('data-label-sold') : 'Sold out';

    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to bag · ' + formatMoney(variant.price) : soldLabel;
    }
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = !available;
      stickyAtcBtn.textContent = available ? 'Add to bag' : 'Sold out';
    }

    // Back-in-stock strip
    const bisWrap = document.querySelector('[data-bis-wrap]');
    if (bisWrap) {
      bisWrap.style.display = available ? 'none' : '';
      const bisBtn = bisWrap.querySelector('[data-notify-me]');
      if (bisBtn) bisBtn.setAttribute('data-variant-id', variant.id);
    }

    // Featured image swap
    if (variant.featured_image) {
      const img = document.querySelector('.rv-gallery__lead-img');
      if (img) {
        img.src = variant.featured_image.src;
        if (variant.featured_image.alt) img.alt = variant.featured_image.alt;
      }
    }
  }

  optionBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const idx = this.getAttribute('data-option-index');
      const val = this.getAttribute('data-value');

      // Deselect siblings in same option group
     document.querySelectorAll(`[data-option-btn][data-option-index="${idx}"]`)
        .forEach(b => b.classList.remove('is-selected'));

      this.classList.add('is-selected');
      selected[idx] = val;

      const variant = findVariant();
      if (variant) updateUI(variant);
    });
  });

  // Init on load
  const initial = findVariant();
  if (initial) updateUI(initial);
})();
